import { Check } from '@hendrx/icons/Check';
import { Group } from '@mantine/core';
import cx from 'clsx';
import { ReactNode } from 'react';

import classes from './SelectOption.module.scss';

type SelectOptionProps = {
  checked?: boolean;
  children: string | ReactNode;
  dataTestId?: string;
};

export function SelectOption(props: SelectOptionProps) {
  const { checked, children, dataTestId } = props;

  return (
    <Group flex="1" gap="sm" className={cx(classes.option, { [classes.checked]: checked })} data-testid={dataTestId}>
      {children}
      {checked && <Check className={classes.checkedIcon} />}
    </Group>
  );
}
